module.exports = __webpack_public_path__ + "/static/assets/fd2c3893224af5e40071e16c1d54060f.png";